import PropTypes from 'prop-types';

const error = {
  statusCode: null,
  message: null,
  errorObject: null,
};

export const errorProps = PropTypes.shape({
  statusCode: PropTypes.number,
  message: PropTypes.string,
  errorObject: PropTypes.object,
});

export default error;
